// import React from 'react';
// import Layout from '../utils/core/Layout';

// const CookiesPolicyPage = () => {
//   return (
//     <Layout>
//       <div className="container py-5" style={{ background: '#cbd4e6ff', color: '#324b68ff', minHeight: '100vh' }}>

//         <h1>Cookies Policy</h1>
//         <p>Last updated: 01 November 2024</p>

//         <p>
//           This Cookies Policy explains how goneet (“we”, “our”, “us”) uses cookies and similar
//           technologies when you visit or use our website, mobile application, or related
//           online services (collectively, the “Platform”). By continuing to use our Platform,
//           you agree to the use of cookies as described in this policy.
//         </p>

//         <h3>1. What Are Cookies?</h3>
//         <p>
//           Cookies are small text files that are stored on your device (computer, mobile,
//           tablet) when you visit a website. Cookies help us recognize your device,
//           remember your preferences, and improve your browsing experience.
//         </p>

//         <h3>2. Why We Use Cookies</h3>
//         <p>We use cookies for various purposes, including:</p>
//         <ul>
//           <li>To enable core website functionality.</li>
//           <li>To remember your login session and prevent repeated sign-ins.</li>
//           <li>To understand how users interact with the Platform.</li>
//           <li>To personalize content and recommendations (job suggestions, profile insights, etc.).</li>
//           <li>To measure performance and improve system stability.</li>
//           <li>To support security and fraud prevention.</li>
//         </ul>

//         <h3>3. Types of Cookies We Use</h3>

//         <h4>3.1 Strictly Necessary Cookies</h4>
//         <p>
//           These cookies are essential for the Platform to function and cannot be disabled.
//           They help with:
//         </p>
//         <ul>
//           <li>User login/session management</li>
//           <li>Security and account protection</li>
//           <li>Page navigation and basic features</li>
//         </ul>

//         <h4>3.2 Performance & Analytics Cookies</h4>
//         <p>
//           These cookies help us understand how visitors use our Platform, which pages are
//           most popular, and where we can improve. For example:
//         </p>
//         <ul>
//           <li>Google Analytics</li>
//           <li>Traffic source tracking</li>
//           <li>User activity heatmaps (if used)</li>
//         </ul>

//         <h4>3.3 Functional Cookies</h4>
//         <p>These cookies allow us to remember your preferences such as:</p>
//         <ul>
//           <li>Language selection</li>
//           <li>Saved searches</li>
//           <li>Job filters and sorting preferences</li>
//         </ul>

//         <h4>3.4 Advertising & Retargeting Cookies (If Enabled)</h4>
//         <p>
//           These cookies may be used to deliver personalized ads or show job recommendations
//           tailored to your profile or browsing patterns. They help us:
//         </p>
//         <ul>
//           <li>Limit how often you see the same ad</li>
//           <li>Measure campaign performance</li>
//           <li>Show relevant job or employer suggestions</li>
//         </ul>

//         <h3>4. Third-Party Cookies</h3>
//         <p>We may allow third-party service providers to set cookies, such as:</p>
//         <ul>
//           <li><b>Google Analytics</b> — usage insights and analytics</li>
//           <li><b>LinkedIn API</b> — login, verification, tracking</li>
//           <li><b>Payment gateways</b> (if applicable) — fraud protection</li>
//           <li><b>Cloudflare / AWS</b> — security and performance optimization</li>
//         </ul>
//         <p>
//           These third parties may collect information independently based on their own
//           policies. We encourage you to review their respective privacy policies.
//         </p>

//         <h3>5. Cookies Used for Job and Profile Personalization</h3>
//         <p>
//           We may use cookies to enhance your job-seeking experience by:
//         </p>
//         <ul>
//           <li>Showing recommended jobs based on your activity</li>
//           <li>Highlighting recruiters or employers interested in your profile</li>
//           <li>Improving search results and feed ranking</li>
//         </ul>
//         <p>
//           These cookies help us make the Platform more relevant and useful to you.
//         </p>

//         <h3>6. Managing or Disabling Cookies</h3>
//         <p>
//           You can control or disable cookies through your browser settings. However,
//           disabling certain cookies may affect website functionality or prevent some
//           features from working properly.
//         </p>

//         <p>You can manage cookies via:</p>
//         <ul>
//           <li>Browser settings (Chrome, Firefox, Safari, Edge)</li>
//           <li>Our cookie consent banner (where available)</li>
//           <li>Private/incognito browsing modes</li>
//         </ul>

//         <h3>7. Data Stored Through Cookies</h3>
//         <p>Cookies may store the following non-sensitive details:</p>
//         <ul>
//           <li>Session tokens (encrypted)</li>
//           <li>Job search filters</li>
//           <li>Device information (browser, OS)</li>
//           <li>Usage preferences</li>
//         </ul>
//         <p>We do not store passwords or sensitive personal data in cookies.</p>

//         <h3>8. Updates to This Cookies Policy</h3>
//         <p>
//           We may update this policy from time to time to reflect technological,
//           legal, or operational changes. Any updates will appear on this page with an
//           updated “Last updated” date.
//         </p>

//         <h3>9. Contact Us</h3>
//         <p>
//           If you have any questions about this Cookies Policy or how we use cookies,
//           please contact us at:
//         </p>

//         <p><b>Email:</b> cookies@goneet.com</p>
//         <p><b>Support:</b> support@goneet.com</p>
//         <p><b>Website:</b> https://goneet.com</p>
//       </div>
//     </Layout>
//   );
// };

// export default CookiesPolicyPage;


// src/components/legal/CookiesPolicyPage.jsx



import { useEffect } from "react";
import Layout from '../utils/core/Layout';
import './CookiesPolicy.css';

const CookiesPolicyPage = () => {

  useEffect(() => {
    // scroll only when the page URL contains #top
    if (window.location.hash === "#top") {
      const heading = document.querySelector(".policy-page");
      if (heading) {
        heading.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, []);

  return (
    <Layout>
      <div className="policy-page">
        <h1 className="policy-title">Cookie Policy</h1>

        {/* Blue banner */}
        <div className="policy-banner">
          <p className="policy-banner-updated">
            <strong>Last Updated:</strong> 27/11/2025
          </p>
          <p className="policy-banner-text">
            PLEASE READ THIS COOKIE POLICY CAREFULLY BEFORE USING OUR PLATFORM
          </p>
        </div>

        <section className="policy-section">
          <p>
            This Cookie Policy explains how goneet (“we”, “our”, “us”) uses cookies and similar
            tracking technologies on our website and mobile applications (collectively, the “Platform”).
            By using the Platform, you agree to the use of cookies as described in this Policy.
          </p>
        </section>

        {/* 1. What Are Cookies */}
        <section className="policy-section">
          <h2>1. What Are Cookies?</h2>
          <p>
            Cookies are small text files stored on your device when you visit a website. They help
            improve your user experience by:
          </p>
          <ul className="policy-list">
            <li className="policy-list-item">• Remembering your preferences</li>
            <li className="policy-list-item">• Enhancing website performance</li>
            <li className="policy-list-item">• Analyzing how you interact with our Platform</li>
          </ul>
          <p>Cookies do not give us access to your device or personal files.</p>
        </section>

        {/* 2. Types of Cookies */}
        <section className="policy-section">
          <h2>2. Types of Cookies We Use</h2>

          <h3>A. Essential / Strictly Necessary Cookies</h3>
          <p>These cookies are required for the Platform to function properly. They enable:</p>
          <ul className="policy-list">
            <li className="policy-list-item">• Login & authentication</li>
            <li className="policy-list-item">• Account security</li>
            <li className="policy-list-item">• Basic navigation</li>
            <li className="policy-list-item">• Preventing fraudulent usage</li>
          </ul>
          <p>You cannot disable these cookies, as the Platform will not work without them.</p>

          <h3>B. Performance & Analytics Cookies</h3>
          <p>
            We use analytics tools (such as Firebase or similar services) to understand how
            users interact with our Platform. These cookies help us:
          </p>
          <ul className="policy-list">
            <li className="policy-list-item">• Measure traffic</li>
            <li className="policy-list-item">• Identify frequently used features</li>
            <li className="policy-list-item">• Improve stability and performance</li>
          </ul>
          <p>All analytics data is anonymized and does not identify you personally.</p>

          <h3>C. Preference Cookies</h3>
          <p>These cookies store your preferences, such as:</p>
          <ul className="policy-list">
            <li className="policy-list-item">• Language</li>
            <li className="policy-list-item">• Location</li>
            <li className="policy-list-item">• UI preferences</li>
          </ul>
          <p>This helps provide a personalized and consistent experience.</p>

          <h3>D. Advertising / Marketing Cookies (If enabled)</h3>
          <p>
            Currently, goneet does <strong>not</strong> use advertising cookies. If we introduce
            them in the future, this policy will be updated and users will be notified.
          </p>
        </section>

        {/* 3. Cookies in Mobile App */}
        <section className="policy-section">
          <h2>3. Cookies in the Mobile App</h2>
          <p>
            Our Android and iOS apps may use local storage or analytics SDKs that function similarly
            to cookies, including:
          </p>
          <ul className="policy-list">
            <li className="policy-list-item">• Tracking app performance</li>
            <li className="policy-list-item">• Crash diagnostics</li>
            <li className="policy-list-item">• User interaction analytics</li>
          </ul>
          <p>We do not track users across other apps or websites.</p>
        </section>

        {/* 4. Third-Party Cookies */}
        <section className="policy-section">
          <h2>4. Third-Party Cookies</h2>
          <p>
            Some cookies may be set by trusted third parties that provide services for our Platform,
            such as:
          </p>
          <ul className="policy-list">
            <li className="policy-list-item">• Hosting providers</li>
            <li className="policy-list-item">• Analytics services</li>
            <li className="policy-list-item">
              • Payment providers (Stripe may place cookies on the web checkout page)
            </li>
          </ul>
          <p>
            These providers may collect technical or usage data to support their functionality.
            We do not allow third parties to collect personal information for advertising.
          </p>
        </section>

        {/* 5. Managing Cookies */}
        <section className="policy-section">
          <h2>5. Managing & Disabling Cookies</h2>

          <h3>Website Users</h3>
          <p>You can disable or delete cookies anytime through your browser settings:</p>
          <ul className="policy-list">
            <li className="policy-list-item">• Chrome</li>
            <li className="policy-list-item">• Firefox</li>
            <li className="policy-list-item">• Safari</li>
            <li className="policy-list-item">• Edge</li>
          </ul>

          <p>Disabling essential cookies may prevent the Platform from functioning.</p>

          <h3>Mobile App Users</h3>
          <p>
            You may disable analytics or tracking features through your device settings
            if supported by your phone. However, some app functions may be affected.
          </p>
        </section>

        {/* 6. Updates */}
        <section className="policy-section">
          <h2>6. Updates to This Cookie Policy</h2>
          <p>
            We may update this Cookie Policy from time to time. When updated, the “Last Updated”
            date will be modified accordingly. Significant changes may be communicated via app
            notifications or email.
          </p>
        </section>

        {/* 7. Contact */}
        <section className="policy-section">
          <h2>7. Contact Us</h2>
          <p>If you have any questions about this Cookie Policy:</p>
          <p><strong>Email:</strong> support@goneet.com</p>
        </section>

      </div>
    </Layout>
  );
};

export default CookiesPolicyPage;
